module.exports = __webpack_public_path__ + "img/product2.4179cd4d.png";